import { downloadBlob } from './downloadFile';

export function sanitizeFilenamePart(s) {
  if (s === null || s === undefined) return 'unknown';
  const cleaned = String(s)
    .replace(/[\s/\\:*?"<>|]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return cleaned || 'unknown';
}

export function downloadJson(payload, filename) {
  downloadBlob(JSON.stringify(payload, null, 2), filename, 'application/json');
}
